import { createTheme, getContrastRatio, darken, lighten } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

import { options } from './utility/options';

const BRAND_COLOR = "#eb304f";

export const theme = createTheme({
  typography: {
    // MUI4 used `Lato, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  palette: {
    primary: {
      main: '#3f51b5', // this is indigo, change it if needed (same as mui4)
    },
    secondary: {
      main: '#f50057', // same as mui4
    },
    brand: {
      main: BRAND_COLOR,
      light: lighten(BRAND_COLOR, 0.1),
      dark: darken(BRAND_COLOR, 0.1),
      contrastText: getContrastRatio(BRAND_COLOR, "#fff") > 4 ? "#fff" : "#111",
    },
    nav: {
      main: options.environment !== 'production' ? 'rgba(235, 48, 79, 0.2)' : '#FEFDFD',
    },
    border: {
      main: "#eee"
    },
    success: {
      main: "#4caf50",
      light: lighten("#4caf50", 0.2),
      dark: darken("#4caf50", 0.2),
      contrastText: "#fff",
    },
    warning: {
      main: "#ff9800",
      light: lighten("#ff9800", 0.2),
      dark: darken("#ff9800", 0.2),
      contrastText: "#fff",
    },
    divider: "rgba(0, 0, 0, 0.12)",
  },
  components: {
    MuiSelect: {
      defaultProps: {
        size: 'small'
      },
      styleOverrides: {
        root: {
          height: 40,
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1
          }
        }
      }
    },
    MuiButton: {
      defaultProps: {
        // this is so that the buttons text colour is black instead of primary(blue)
        // the ones that are set to primary are still blue(due to the default theme being blue for primary)
        color: 'inherit'
      },
      styleOverrides: {
        // For <Button variant="contained"> to look like v4's default grey button
        containedPrimary: {
          backgroundColor: grey[300],
          color: 'rgba(0, 0, 0, 0.87)',
          '&:hover': {
            backgroundColor: '#d5d5d5',
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          // mui5 removes padding from the top of the dialog content by default
          // and it was cutting off the top of the <TextField /> label
          '&.MuiDialogContent-root': {
            paddingTop: "8px",
          },
        },
      },
    },
    // Look at adding size="large" instead where needed
    // That would fix the need of setting height and width to auto on InputAdornment components
    MuiIconButton: {
      styleOverrides: {
        root: {
          width: 48,
          height: 48,
          padding: 12,
        },
        sizeSmall: {
          width: 32,
          height: 32,
          padding: 8,
        }
      }
    }
  }
});
